import { lazy } from 'react';

const AcademicYear = lazy(() =>
  import(/* webpackChunkName: "AcademicYear" */ '~containers/academic-year')
);
const AdditionalFees = lazy(() =>
  import(/* webpackChunkName: "AdditionalFees" */ '~containers/additional-fees')
);
const BedAvailability = lazy(() =>
  import(/* webpackChunkName: "BedAvailability" */ '~containers/bed-availability')
);
const BedType = lazy(() => import(/* webpackChunkName: "BedType" */ '~containers/bed-type'));
const Booking = lazy(() => import(/* webpackChunkName: "Booking" */ '~containers/booking'));
const BookingDetails = lazy(() =>
  import(/* webpackChunkName: "BookingDetails" */ '~containers/booking/booking-details')
);
const CheckInTasks = lazy(() =>
  import(/* webpackChunkName: "CheckInTasks" */ '~containers/check-in-tasks')
);
const ContractTemplates = lazy(() =>
  import(/* webpackChunkName: "ContractTemplates" */ '~containers/contract-templates')
);
const DashBoard = lazy(() => import(/* webpackChunkName: "DashBoard" */ '~containers/dashboard'));
const EmailTemplates = lazy(() =>
  import(/* webpackChunkName: "EmailTemplates" */ '~containers/email-templates')
);
const FlexibilityControl = lazy(() =>
  import(/* webpackChunkName: "FlexibilityControl" */ '~containers/flexibility-control')
);
const CustomFields = lazy(() =>
  import(/* webpackChunkName: "CustomFields" */ '~containers/custom-fields')
);
const Documents = lazy(() => import(/* webpackChunkName: "Documents" */ '~containers/documents'));

const Guarantors = lazy(() =>
  import(/* webpackChunkName: "Guarantors" */ '~containers/guarantors')
);

const Installment = lazy(() =>
  import(/* webpackChunkName: "InstallMent" */ '~containers/installment')
);
const NominationManageBeds = lazy(() =>
  import(/* webpackChunkName: "NominationManageBeds" */ '~containers/nomination-manage-beds')
);
const NominationManageStudents = lazy(() =>
  import(
    /* webpackChunkName: "NominationManageStudents" */ '~containers/nomination-manage-students'
  )
);
const NominationPlanSettings = lazy(() =>
  import(/* webpackChunkName: "NominationPlanSettings" */ '~containers/nomination-plan-settings')
);
const NominationFinanceBalance = lazy(() =>
  import(/* webpackChunkName: "NominationPlanSettings" */ '~containers/nomination-finance-balance')
);
const Nominations = lazy(() =>
  import(/* webpackChunkName: "Nominations" */ '~containers/nominations')
);

const ApprovalCenter = lazy(() =>
  import(/* webpackChunkName: "ApprovalCenter" */ '~containers/approval-center')
);

const OccupancyChart = lazy(() =>
  import(/* webpackChunkName: "EmailTemplates" */ '~containers/occupancy-chart')
);
const Partners = lazy(() => import(/* webpackChunkName: "Partners" */ '~containers/partners'));
const PaymentGateways = lazy(() =>
  import(/* webpackChunkName: "PaymentGateways" */ '~containers/payment-gateways')
);
const PropertyStructure = lazy(() =>
  import(/* webpackChunkName: "PropertyStructure" */ '~containers/property-structure')
);
const RateCard = lazy(() => import(/* webpackChunkName: "RateCard" */ '~containers/rate-card'));
const RoomGroup = lazy(() => import(/* webpackChunkName: "RoomType" */ '~containers/room-group'));
const RoomType = lazy(() => import(/* webpackChunkName: "RoomType" */ '~containers/room-type'));
const RulePreferences = lazy(() =>
  import(/* webpackChunkName: "DynamicGender" */ '~containers/rule-preferences')
);
const SalesItems = lazy(() =>
  import(/* webpackChunkName: "SalesItem" */ '~containers/sales-items')
);
const Setting = lazy(() => import(/* webpackChunkName: "Setting" */ '~containers/setting'));
const Student = lazy(() => import(/* webpackChunkName: "Student" */ '~containers/student/list'));
const StudentDetails = lazy(() =>
  import(/* webpackChunkName: "Student" */ '~containers/student/detail')
);
const TenancyOptions = lazy(() =>
  import(/* webpackChunkName: "TenancyOptions" */ '~containers/tenancy-options')
);
const UserAccount = lazy(() =>
  import(/* webpackChunkName: "EmailTemplates" */ '~containers/user-account')
);
const SpecialOffers = lazy(() =>
  import(/* webpackChunkName: "SpecialOffers" */ '~containers/special-offers')
);
const CampaignTemplates = lazy(() =>
  import(/* webpackChunkName: "CampaignTemplates" */ '~containers/campaign-templates')
);
const Approvals = lazy(() =>
  import(/* webpackChunkName: "CampaignTemplates" */ '~containers/approvals')
);

const Announcements = lazy(() =>
  import(/* webpackChunkName: "Announcements" */ '~containers/in-residence/announcements')
);

const ParcelManagement = lazy(() =>
  import(/* webpackChunkName: "ParcelManagement" */ '~containers/in-residence/parcel-management')
);

const TicketManagement = lazy(() =>
  import(/* webpackChunkName: "TicketManagement" */ '~containers/in-residence/ticket-management')
);

const EventManagement = lazy(() =>
  import(/* webpackChunkName: "EventManagement" */ '~containers/in-residence/event-management')
);

const PropertyOnboarding = lazy(() =>
  import(/* webpackChunkName: "EventManagement" */ '~containers/property-onboarding')
);

const ImportRecords = lazy(() =>
  import(/* webpackChunkName: "ImportRecords" */ '~containers/import-records')
);

export const routes = {
  '/booking': {
    Component: Booking,
    slugs: ['booking'],
  },
  '/booking/booking-details': {
    Component: BookingDetails,
    slugs: ['booking', 'booking-details'],
  },
  '/dashboard': {
    Component: DashBoard,
    slugs: ['dashboard'],
  },
  '/inventory/bed-availability': {
    Component: BedAvailability,
    slugs: ['inventory', 'bed-availability'],
  },
  '/inventory/occupancy-chart': {
    Component: OccupancyChart,
    slugs: ['inventory', 'occupancy-chart'],
  },
  '/approval-center': {
    Component: ApprovalCenter,
    slugs: ['approval-center'],
  },
  '/import-records': {
    Component: ImportRecords,
    slugs: ['booking', 'booking-details', 'import-bookings'],
  },
  '/nominations': {
    Component: Nominations,
    slugs: ['nominations'],
  },
  '/nominations/manage-beds': {
    Component: NominationManageBeds,
    slugs: ['nominations'],
  },
  '/nominations/manage-students': {
    Component: NominationManageStudents,
    slugs: ['nominations'],
  },
  '/nominations/nomination-plan-settings': {
    Component: NominationPlanSettings,
    slugs: ['nominations'],
  },
  '/nominations/nomination-finance-balance': {
    Component: NominationFinanceBalance,
    slugs: ['nominations'],
  },
  '/partners': {
    Component: Partners,
    slugs: ['partners'],
  },
  '/settings': {
    Component: Setting,
    slugs: ['settings'],
  },
  '/settings/admin/user-accounts': {
    Component: UserAccount,
    slugs: ['settings', 'admin', 'user-accounts'],
  },
  '/settings/admin/approvals': {
    Component: Approvals,
    slugs: ['settings', 'admin', 'approvals'],
  },
  '/settings/booking-config/check-in-tasks': {
    Component: CheckInTasks,
    slugs: ['settings', 'booking-config', 'check-in-tasks'],
  },
  '/settings/booking-config/contract-templates': {
    Component: ContractTemplates,
    slugs: ['settings', 'booking-config', 'contract-templates'],
  },
  '/settings/booking-config/email-templates': {
    Component: EmailTemplates,
    slugs: ['settings', 'booking-config', 'email-templates'],
  },
  '/settings/booking-config/custom-fields': {
    Component: CustomFields,
    slugs: ['settings', 'booking-config', 'custom-fields'],
  },
  '/settings/booking-config/documents': {
    Component: Documents,
    slugs: ['settings', 'booking-config', 'documents'],
  },
  '/settings/booking-config/guarantors': {
    Component: Guarantors,
    slugs: ['settings', 'booking-config', 'guarantors'],
  },
  '/settings/payment-config/additional-fees': {
    Component: AdditionalFees,
    slugs: ['settings', 'payment-config', 'additional-fees'],
  },
  '/settings/payment-config/installments': {
    Component: Installment,
    slugs: ['settings', 'payment-config', 'installments'],
  },
  '/settings/payment-config/payment-gateways': {
    Component: PaymentGateways,
    slugs: ['settings', 'payment-config', 'payment-gateways'],
  },
  '/settings/payment-config/sales-items': {
    Component: SalesItems,
    slugs: ['settings', 'payment-config', 'sales-items'],
  },
  '/settings/payment-config/special-offers': {
    Component: SpecialOffers,
    slugs: ['settings', 'payment-config', 'special-offers'],
  },
  '/settings/pricing-config/rate-cards': {
    Component: RateCard,
    slugs: ['settings', 'pricing-config', 'rate-cards'],
  },
  '/settings/pricing-config/room-groups': {
    Component: RoomGroup,
    slugs: ['settings', 'pricing-config', 'room-groups'],
  },
  '/settings/pricing-config/tenancy-options': {
    Component: TenancyOptions,
    slugs: ['settings', 'pricing-config', 'tenancy-options'],
  },
  '/settings/property-config/academic-years': {
    Component: AcademicYear,
    slugs: ['settings', 'property-config', 'academic-years'],
  },
  '/settings/property-config/bed-types': {
    Component: BedType,
    slugs: ['settings', 'property-config', 'bed-types'],
  },
  '/settings/property-config/property-structure': {
    Component: PropertyStructure,
    slugs: ['settings', 'property-config', 'property-structure'],
  },
  '/settings/property-config/room-types': {
    Component: RoomType,
    slugs: ['settings', 'property-config', 'room-types'],
  },
  '/settings/property-config/rules-preferences': {
    Component: RulePreferences,
    slugs: ['settings', 'property-config', 'rules-preferences'],
  },
  '/settings/process-config/flexibility-control': {
    Component: FlexibilityControl,
    slugs: ['settings', 'process-config', 'flexibility-control'],
  },
  '/settings/process-config/sales-plans': {
    Component: CampaignTemplates,
    slugs: ['settings', 'process-config', 'sales-plans'],
  },
  '/student': {
    Component: Student,
    slugs: ['student'],
  },
  '/student/student-details/personal-information': {
    Component: StudentDetails,
    slugs: ['student', 'student-details', 'personal-information'],
  },
  '/in-residence/announcements': {
    Component: Announcements,
    slugs: ['in-residence', 'announcements'],
  },
  '/in-residence/parcel-management': {
    Component: ParcelManagement,
    slugs: ['in-residence', 'parcel-management'],
  },
  '/in-residence/ticket-management': {
    Component: TicketManagement,
    slugs: ['in-residence', 'ticket-management'],
  },
  '/in-residence/event-management': {
    Component: EventManagement,
    slugs: ['in-residence', 'event-management'],
  },
  '/settings/admin/property-onboarding': {
    Component: PropertyOnboarding,
    slugs: ['settings', 'admin', 'property-onboarding'],
  },
};
